import { useState, useEffect } from 'react';

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      id: 1,
      question: 'どのようなペットに対応していますか？',
      answer:
        '小鳥やハムスターなどの小動物から、猫、小型犬、大型犬まで、すべてのペットに対応しております。ペットの大きさや種類に応じて、最適な火葬プランをご提案させていただきます。',
    },
    {
      id: 2,
      question: '火葬の立ち会いは可能ですか？',
      answer:
        'はい、可能です。個別火葬プランでは、ご家族の立ち会いのもと、大切なペットを丁寧にお見送りいたします。お別れの時間を十分に取っていただけるよう、ゆっくりとした環境をご用意しております。',
    },
    {
      id: 3,
      question: '遺骨は返してもらえますか？',
      answer:
        'はい、個別火葬プランでは、火葬後にご遺骨をお返しいたします。また、合同納骨での永代供養や、個別納骨棚での供養もお選びいただけます。ご希望に応じて最適なプランをご提案いたします。',
    },
    {
      id: 4,
      question: '料金はどのくらいかかりますか？',
      answer:
        'ペットの大きさや選ばれるプランによって料金が異なります。小動物は15,000円から、大型犬は50,000円からとなっております。詳しくは料金表ページをご覧いただくか、お電話にてお問い合わせください。',
    },
    {
      id: 5,
      question: '急なお別れでも対応してもらえますか？',
      answer:
        'はい、24時間365日対応しております。深夜や早朝でも、お電話いただければすぐに対応させていただきます。大切なペットとの突然のお別れにも、心を込めてサポートいたします。',
    },
    {
      id: 6,
      question: '納骨はどのくらいの期間できますか？',
      answer:
        '個別納骨棚は3年単位でご利用いただけます。期間終了後は、延長または合同納骨への移行をお選びいただけます。合同納骨の場合は、永代供養となりますので、期間の制限はございません。',
    },
  ];

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://okayama-pet-funeral.example.com';
    
    // Add FAQ structured data
    const faqStructuredData = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    };

    let script = document.querySelector('script[data-faq-structured-data]');
    if (!script) {
      script = document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.setAttribute('data-faq-structured-data', 'true');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(faqStructuredData);

    return () => {
      const scriptToRemove = document.querySelector('script[data-faq-structured-data]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-r from-purple-100 to-pink-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-gray-800 mb-3">
            よくある質問
          </h2>
          <p className="text-base text-gray-600">
            お客様からよくいただくご質問にお答えします
          </p>
        </div>

        <div className="space-y-5">
          {faqs.map((faq, index) => (
            <div
              key={faq.id}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-purple-50 transition-colors"
              >
                <div className="flex items-start gap-4 flex-1">
                  <div className="flex-shrink-0 w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center font-bold text-sm">
                    Q
                  </div>
                  <span className="text-base sm:text-lg font-bold text-gray-800 flex-1 pt-0.5">
                    {faq.question}
                  </span>
                </div>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-purple-500 flex-shrink-0 transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5 border-t border-purple-100">
                  <div className="flex items-start gap-4 pt-5">
                    <div className="flex-shrink-0 w-8 h-8 bg-pink-200 text-white rounded-full flex items-center justify-center font-bold text-sm">
                      A
                    </div>
                    <p className="text-base text-gray-700 leading-relaxed flex-1">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
